import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { jt, t } from 'ttag'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import dislikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'

import {
  closeSetupModal,
  deleteSection,
  dismissPermissions,
  finishProfileSetup,
  rateProfile,
  reorder,
  selectForEdit,
  toggleDrag,
  toggleProfileModal
} from '../../actions/profileViewActions'
import ProfileSectionCms from '../../components/profiles/sections/ProfileSectionCms'
import ProfileSectionTwitter from '../../components/profiles/sections/ProfileSectionTwitter'
import ProfileSectionYoutube from '../../components/profiles/sections/ProfileSectionYoutube'
import ProfileSectionMedia from '../../components/profiles/sections/ProfileSectionMedia'
import ProfileSectionLinkedContent from '../../components/profiles/sections/ProfileSectionLinkedContent'
import ProfileSectionEmployCriteria from '../../components/profiles/sections/ProfileSectionEmployCriteria'
import ProfileSectionCertificationDetail from '../../components/profiles/sections/ProfileSectionCertificationDetail'
import ProfileSectionMap from '../../components/profiles/sections/ProfileSectionMap'
import ProfileSectionJobListing from '../../components/profiles/sections/ProfileSectionJobListing'
import ProfileSectionPromotedDocument from '../../components/profiles/sections/ProfileSectionPromotedDocument'
import ProfileSectionCalendar from '../../components/profiles/sections/ProfileSectionCalendar'
import ProfileSectionWIP from '../../components/profiles/sections/ProfileSectionWIP'
import ProfileSectionIP from '../../components/profiles/sections/ProfileSectionIP'
import ProfileSectionSP from '../../components/profiles/sections/ProfileSectionSP'
import ProfileSectionWK from '../../components/profiles/sections/ProfileSectionWK'
import ProfileSectionSummaryQualifications from '../../components/profiles/sections/ProfileSectionSummaryQualifications'
import ProfileSectionSurvey from '../../components/profiles/sections/ProfileSectionSurvey'
import ProfileSectionIndeedJobListing from '../../components/profiles/sections/ProfileSectionIndeedJobListing'
import ProfileSectionContact from '../../components/profiles/sections/ProfileSectionContact'
import ProfileSectionSearchTags from '../../components/profiles/sections/ProfileSectionSearchTags'
import PopupJournal from '../../components/journal/PopupJournal'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import ProfileSectionAutoCluster from '../../components/profiles/sections/ProfileSectionAutoCluster'
import ProfileSectionAutoWBL from '../../components/profiles/sections/ProfileSectionAutoWBL'
import { ExpressInterest } from '../../components/profiles/ExpressInterest'
import WBLPromoteApplication from '../../components/profiles/sections/WBLPromoteApplication'
import WBLApplicationDetails from '../../components/profiles/sections/WBLApplicationDetails'
import WBLOpportunitiesOffered from '../../components/profiles/sections/WBLOpportunitiesOffered'
import withDnd from '../../components/withDnd'
import { useQuery } from '../../util/hooks'
import ContentSnippetWizard from '../ContentSnippetWizard'

const YouAndOpportunity = ({ profile, openModal, closeModal, selectedModal }) => {
  const dispatch = useDispatch()
  const opportunityType = () => {
    switch (profile.type) {
      case 'company':
        return t`Company`
      case 'offeringtype':
        return t`Opportunity Type`
      case 'institution':
        return t`Institution`
      case 'program':
        return t`Program`
      case 'certification':
        return t`Certification`
      default:
        return t`Opportunity`
    }
  }

  if (!profile?.allowPersonalization) {
    return null
  }

  const per = profile.personalization
  const rating = per && per.hasOwnProperty('rating') ? per.rating : null
  const lastView = new Date(per?.lastView).toLocaleDateString()
  const opportunityTypeName = opportunityType()
  const queryParams = useQuery()

  return (
    <div id="profileinfocontainer">
      <div className="youandocc">
        <h3>{t`You and This ${opportunityTypeName}`}</h3>
        <div className="row" style={{ marginRight: 0 }}>
          <div className="useractions col-xs-6">
            <div className="itemrating">
              <a onClick={() => dispatch(rateProfile(profile, profile.type, 5))}>
                <img
                  src={rating && rating >= 3 ? like : likeInactive}
                  alt={t`Thumbs Up for Like Profile Link`}
                />
              </a>
              <a onClick={() => dispatch(rateProfile(profile, profile.type, 1))}>
                <img
                  src={rating && rating < 3 ? dislike : dislikeInactive}
                  alt={t`Thumbs down for Dislike Profile Link`}
                />
              </a>
              {t`Your Rating`}
            </div>
          </div>

          <div className="col-xs-9">
            {profile.type == 'offeringtype' && !profile.applicationsDisabledToWBL && (
              <ExpressInterest
                profile={profile}
                selectedCluster={queryParams?.selectedCluster}
              />
            )}
          </div>
          <div className="col-xs-3 history-item">
            <div className={`personalize-history`}>
              <h4 className={((per && per.journals) || []).length ? 'hasData' : ''}>
                {((per && per.journals) || []).length || 0}
              </h4>
              <span>{t`Journals`}</span>
              <button onClick={() => openModal('journal', true)}>{t`Add`}</button>
            </div>
          </div>
        </div>
        {per?.lastView && (
          <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
        )}
      </div>
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={selectedModal === 'journal'}
        onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {per.journals && (
            <PopupJournal
              journals={per.journals}
              objectType={per.journalType}
              objectId={`${profile.id}`}
              objectTitle={profile.title}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

YouAndOpportunity.propTypes = {
  profile: PropTypes.string,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  selectedModal: PropTypes.string
}
const renderInner = (section, dispatch, profile, eventEditError, surveys) => {
  switch (section.type) {
    case 0:
      return <ProfileSectionMedia section={section} />
    case 1:
      //This allows us to use a templated output instead of pulling from the body field
      const queryParams = useQuery()

      if (section.sectionTemplateId) {
        switch (section.sectionTemplateId) {
          case 'wbl_promote_application':
            return (
              <WBLPromoteApplication
                profile={profile}
                section={section}
                selectedCluster={queryParams?.selectedCluster}
              />
            )
          case 'wbl_application_section':
            return (
              <WBLApplicationDetails
                profile={profile}
                section={section}
                selectedCluster={queryParams?.selectedCluster}
              />
            )
          case 'wbl_opportunities_offered':
            return (
              <WBLOpportunitiesOffered
                profile={profile}
                section={section}
                selectedCluster={queryParams?.selectedCluster}
              />
            )
        }
      }

      //this return is here since calling by tag returns a react proxy which can't be detected as null
      if (!section.displayAttribution) {
        return null
      }

      return <ProfileSectionCms section={section} />
    case 2: //calendar
      return (
        <ProfileSectionCalendar
          dispatch={dispatch}
          surveys={surveys}
          eventEditError={eventEditError}
          section={section}
          profile={profile}
        />
      )
    case 3: //onet
    case 4: //college
    case 12: //profiles
    case 37:
      return <ProfileSectionLinkedContent section={section} expanded={true} />
    case 27: //clusters
      return (
        <ProfileSectionLinkedContent
          section={section}
          expanded={false}
          hideDescription={true}
        />
      )
    case 5: //training
    case 6: //certification
    case 13: //additional resources
    case 16: //naics
    case 38: //cip
    case 21: //file listing
      return <ProfileSectionLinkedContent section={section} expanded={false} />
    case 7: //Job orders
      return (
        <ProfileSectionIndeedJobListing
          section={section}
          profile={profile}
          dispatch={dispatch}
        />
      )
    case 28:
      return (
        <ProfileSectionJobListing
          section={section}
          profile={profile}
          dispatch={dispatch}
        />
      )
    case 29:
      return (
        <ProfileSectionContact section={section} profile={profile} dispatch={dispatch} />
      )
    case 30:
      return (
        <ProfileSectionSearchTags
          section={section}
          profile={profile}
          expanded={true}
          dispatch={dispatch}
        />
      )
    case 31:
    case 34:
    case 35:
      return (
        <ProfileSectionAutoCluster
          section={section}
          profile={profile}
          expanded={true}
          dispatch={dispatch}
        />
      )
    case 32:
      return (
        <ProfileSectionAutoWBL
          section={section}
          profile={profile}
          expanded={true}
          hideDescription={false}
          dispatch={dispatch}
        />
      )
    case 33:
    case 36:
      return (
        <ProfileSectionAutoWBL
          section={section}
          profile={profile}
          expanded={false}
          hideDescription={false}
          dispatch={dispatch}
        />
      )
    case 8: //location
      return <ProfileSectionMap section={section} />
    case 9: //announcement
      return null
    case 10:
      return <ProfileSectionTwitter section={section} />
    case 11:
      return <ProfileSectionYoutube section={section} />
    case 14: //survey
      return (
        <ProfileSectionSurvey dispatch={dispatch} section={section} profile={profile} />
      )
    case 22:
      return <ProfileSectionSummaryQualifications section={section} /> //SummaryQualificationsSection
    case 15: //certification details
      return <ProfileSectionCertificationDetail section={section} />
    case 17:
      return <ProfileSectionIP section={section} /> //IP
    case 18: //WIP
      return <ProfileSectionWIP section={section} />
    case 19: //SP
      return <ProfileSectionSP section={section} /> //IP
    case 20: //WorkKeys
      return <ProfileSectionWK section={section} /> //AssessmentSection
    case 24: //promoted document
      return <ProfileSectionPromotedDocument section={section} />
    case 25:
      return <ProfileSectionEmployCriteria section={section} />
    case 26:
      return <ProfileSectionEmployCriteria section={section} />
    default:
      return null
  }
}
const addEdit = (onSelectForEdit, canEdit, section) => {
  if (canEdit) {
    return (
      <a
        onClick={() => onSelectForEdit(section)}
        className="edit pull-right profile-edit-link">
        <span className="sr-only">{t`edit`}</span>
      </a>
    )
  }

  return null
}
const addDelete = (onSelectForDelete, canEdit, section) => {
  const confirmDelete = () => {
    if (confirm(t`Are you sure you want to delete: ${section.title}`)) {
      onSelectForDelete(section.id)
    }
  }

  //don't add if the templateId is set
  if (section.sectionTemplateId) {
    return null
  }

  if (canEdit) {
    return (
      <a
        onClick={confirmDelete}
        style={{ marginLeft: '6px' }}
        className="delete pull-right profile-edit-link">
        <span className="sr-only">{t`delete`}</span>
      </a>
    )
  }

  return null
}
const addTitle = (canEdit, section, dragHandleProps) => {
  if (section.suppressTitle) {
    if (canEdit) {
      return (
        <a className="profile-edit-link" {...dragHandleProps}>
          <i className="fal fa-arrows" aria-hidden="true"></i>
        </a>
      )
    }

    return null
  }

  return (
    <h3
      className={canEdit ? 'section-title drag-title' : 'section-title'}
      {...dragHandleProps}>
      {section.title}
    </h3>
  )
}
const ProfileSection = ({
  section,
  onSelectForEdit,
  surveys,
  onSelectForDelete,
  dragProps,
  dragHandleProps,
  profile,
  canEdit,
  eventEditError
}) => {
  const dispatch = useDispatch()
  const sectionContent = renderInner(section, dispatch, profile, eventEditError, surveys)
  const contentHandledInTemplate = !!section.sectionTemplateId && section.type == 1
  const hasContent = !!sectionContent
  //console.log("SECTION", hasContent, sectionContent, section.id)
  const sectionWidth = hasContent ? 4 : 6
  let middleSize = 12

  if (section.floatBodyLeft) {
    middleSize = middleSize - sectionWidth
  }

  if (section.floatBodyRight) {
    middleSize = middleSize - sectionWidth
  }

  return (
    <div className="section-body" {...dragProps}>
      {addDelete(onSelectForDelete, canEdit, section)}
      {addEdit(onSelectForEdit, canEdit, section)}
      {addTitle(canEdit, section, dragHandleProps)}
      <div className={`row ${section.sectionCssClass || ''}`}>
        {!contentHandledInTemplate && (section.body || section.floatBodyLeft) && (
          <p
            dangerouslySetInnerHTML={{ __html: section.body }}
            className={
              section.floatBodyLeft ? `col-xs-12 col-sm-${sectionWidth}` : 'col-xs-12'
            }>
          </p>
        )}
        {hasContent ? (
          <div className={`col-sm-${middleSize}`}>{sectionContent}</div>
        ) : null}
        {!contentHandledInTemplate && (section.footer || section.floatBodyRight) && (
          <p
            dangerouslySetInnerHTML={{ __html: section.footer }}
            className={
              section.floatFooterRight ? `col-xs-12 col-sm-${sectionWidth}` : 'col-xs-12'
            }>
          </p>
        )}
      </div>
    </div>
  )
}

ProfileSection.propTypes = {
  section: PropTypes.string,
  onSelectForEdit: PropTypes.func,
  surveys: PropTypes.object,
  onSelectForDelete: PropTypes.func,
  dragProps: PropTypes.object,
  dragHandleProps: PropTypes.object,
  profile: PropTypes.object,
  canEdit: PropTypes.bool,
  eventEditError: PropTypes.func,
  location: PropTypes.object,
  style: PropTypes.string
}

const ProfileBody = ({
  onReorder,
  profile,
  surveys,
  isDragging,
  onDeleteSection,
  onToggleDrag,
  onSelectForEdit,
  onSelectForDelete,
  eventEditError,
  openModal,
  closeModal,
  selectedModal,
  DragDropContext,
  Draggable,
  Droppable,
  editingEnabled
}) => {
  /* We use this to guess the column widths for dynamically specified numbers of columns*/
  const classNames = {
    1: ['col-sm-12'],
    2: ['col-sm-8', 'col-sm-4'],
    3: ['col-sm-3', 'col-sm-6', 'col-sm-3'],
    4: ['col-sm-3', 'col-sm-3', 'col-sm-3', 'col-sm-3']
  }
  const dispatch = useDispatch()
  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#ddd' : 'transparent',
    padding: 8
  })
  const getItemStyle = draggableStyle => {
    const style = {
      userSelect: 'none',
      padding: '0 16px 8px 16px',
      marginBottom: '8px',
      ...draggableStyle
    }

    return editingEnabled ? style : {}
  }
  const generateSections = (profile, i) => {
    const sections = profile.sections
      .filter(s => s.column === i + 1)
      .sort((a, b) => a.row - b.row)

    return sections
  }

  return (
    <DragDropContext
      onDragStart={() => onToggleDrag(true)}
      onDragEnd={result => {
        onToggleDrag(false)

        if (!result.destination) {
        } else if (result.destination && result.destination.droppableId === 'delete') {
          onDeleteSection(profile.type, profile.id, result.draggableId)
        } else {
          const json = {
            newPosition: result.destination.index + 1,
            newColumn: parseInt(result.destination.droppableId)
          }

          onReorder(profile.type, profile.id, result.draggableId, json)
        }
      }}>
      <div className={`row ${isDragging ? 'indrag' : ''}`} id="colwrap">
        {new Array(profile.columns).fill().map((_, i) => (
          <Droppable key={`drop-${i}`} droppableId={`${i + 1}`}>
            {(provided, ss) => {
              //                            console.log("DROP", provided, ss, provided.placeholder);
              return (
                <div
                  style={getListStyle(ss.isDraggingOver)}
                  id={`column${i + 1}`}
                  key={`col${i}`}
                  ref={provided.innerRef}
                  className={`content-column ${classNames[profile.columns][i]} ${
                    ss.isDraggingOver ? 'dragging' : ''
                  }`}>
                  {(() => {
                    const itms = generateSections(profile, i).map((section, rowIdx) => {
                      return (
                        <Draggable
                          key={section.id}
                          draggableId={`${section.id}`}
                          index={rowIdx}
                          isDragDisabled={
                            !(
                              (profile.permissions.canAdminister ||
                                profile.permissions.canEdit) &&
                              editingEnabled
                            )
                          }>
                          {(provided, snapshot) => {
                            //                                                      console.log("DRAG", provided, ss, provided.dragHandleProps)
                            return (
                              <div
                                ref={provided.innerRef}
                                className="section"
                                style={getItemStyle(
                                  provided.draggableStyle,
                                  snapshot.isDragging,
                                  ss.isDraggingOver
                                )}
                                key={`profileRow${rowIdx}`}>
                                <ProfileSection
                                  section={section}
                                  profile={profile}
                                  surveys={surveys}
                                  dispatch={dispatch}
                                  eventEditError={eventEditError}
                                  canEdit={
                                    (profile.permissions.canAdminister ||
                                      profile.permissions.canEdit) &&
                                    editingEnabled
                                  }
                                  onSelectForEdit={onSelectForEdit(
                                    profile.type,
                                    profile.id
                                  )}
                                  onSelectForDelete={onSelectForDelete(
                                    profile.type,
                                    profile.id
                                  )}
                                  dragHandleProps={provided.dragHandleProps}
                                  dragProps={provided.draggableProps}
                                />
                                {provided.placeholder}
                              </div>
                            )
                          }}
                        </Draggable>
                      )
                    })

                    return profile.columns > 1 && i == profile.columns - 1
                      ? [
                          <YouAndOpportunity
                            key="youandopp-profile"
                            dispatch={dispatch}
                            profile={profile}
                            closeModal={closeModal}
                            selectedModal={selectedModal}
                            openModal={openModal}
                          />,
                          ...itms
                        ]
                      : itms
                  })()}
                  {provided.placeholder}
                </div>
              )
            }}
          </Droppable>
        ))}
      </div>
    </DragDropContext>
  )
}

ProfileBody.propTypes = {
  onReorder: PropTypes.func,
  editingEnabled: PropTypes.bool,
  profile: PropTypes.object,
  surveys: PropTypes.object,
  isDragging: PropTypes.boolean,
  onDeleteSection: PropTypes.func,
  onToggleDrag: PropTypes.func,
  onSelectForEdit: PropTypes.func,
  onSelectForDelete: PropTypes.func,
  eventEditError: PropTypes.object,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  selectedModal: PropTypes.func,
  DragDropContext: PropTypes.func,
  Draggable: PropTypes.func,
  Droppable: PropTypes.func
}

const RenderProfile = props => {
  if (!props.profile || !props.profile.type) {
    return null
  }

  return (
    <>
      <ProfileBody {...props} />
      <ContentSnippetWizard />
    </>
  )
}

RenderProfile.propTypes = {
  profile: PropTypes.object
}

const stateToProps = state => {
  return {
    ...state.profileView,
    surveys: state.surveyEdit
  }
}
const dispatchToProps = dispatch => ({
  dispatch,
  onToggleDrag: s => dispatch(toggleDrag(s)),
  onDeleteSection: (profileType, profileId, sectionId) =>
    dispatch(deleteSection(profileType, profileId, sectionId)),
  onHideModal: () => dispatch(closeSetupModal()),
  onSetupProfile: (profileType, profileId, data) =>
    dispatch(finishProfileSetup(profileType, profileId, data)),
  onDismissPermissions: () => dispatch(dismissPermissions()),
  onSelectForDelete: (profileType, profileId) => section =>
    dispatch(deleteSection(profileType, profileId, section)),
  onSelectForEdit: (profileType, profileId) => section =>
    dispatch(selectForEdit(profileType, profileId, section)),
  onReorder: (profileType, profileId, draggableId, json) => {
    dispatch(reorder(profileType, profileId, draggableId, json))
  },
  openModal: (modalName, requireLoggedIn) => {
    if (!!requireLoggedIn && !dynamicValues.userProfile) {
      dispatch(openSigninDialog('signIn'))
    } else {
      dispatch(toggleProfileModal(modalName))
    }
  },
  closeModal: () => dispatch(toggleProfileModal(null))
})

export default withDnd(connect(stateToProps, dispatchToProps)(RenderProfile))
